import * as React from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
export const Layout = /*#__PURE__*/React.forwardRef(function Layout({
  as = 'div',
  children,
  className,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(as, {
    role: 'presentation',
    ...rest,
    className: clsx(className, styles.layout),
    ref
  }, children);
});